import {
  handleMouseEnter,
  handleMouseLeave,
  handleNavbarClick,
  handleSidebarClick,
} from "../ThemeHelper";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getAdminToken } from "../../context/AuthContext";

const SuperAdminSidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(true);

  useEffect(() => {
    const token = getAdminToken();
    if (!token && location.pathname !== "/super-admin/login") {
      navigate("/super-admin/login");
    }
  }, [location.pathname, navigate]);

  return (
    <aside
      id="layout-menu"
      className="layout-menu menu-vertical menu bg-menu-theme"
      onMouseEnter={() => {
        handleMouseEnter();
        setIsSidebarOpen(true);
      }}
      onMouseLeave={() => {
        setIsSidebarOpen(handleMouseLeave());
      }}
    >
      <div className="app-brand demo">
        {isSidebarOpen ? (
          <>
            <Link
              to="/dashboard"
              className="app-brand-link"
              title={"ERP"}
              style={{ width: "197px", overflow: "hidden" }}
            >
              <span
                className="app-brand-logo demo"
                style={{ alignItems: "unset" }}
              >
                <div className="d-flex align-items-center">
                  <img
                    src={`/img/logo/skyline-logo.svg`}
                    alt={"ERP"}
                    style={{
                      height: "62px",
                      width: "160px",
                    }}
                  />
                </div>
              </span>
            </Link>
            <Link
              to="#"
              className="layout-menu-toggle menu-link text-large ms-auto"
              onClick={(e: any) => handleSidebarClick(e)}
            >
              <i className="ti menu-toggle-icon d-none d-xl-block align-middle"></i>
              <i
                className="ti ti-x d-block d-xl-none ti-md align-middle"
                onClick={(e: any) => handleNavbarClick(e)}
              ></i>
            </Link>
          </>
        ) : (
          <div className="app-brand demo">
            <Link
              to="/super-admin/dashboard"
              className="app-brand-link"
              title="MS Laxmi Enterprise"
            >
              <span className="demo menu-text fw-bold">SA</span>
            </Link>
          </div>
        )}
      </div>
      <div className="menu-inner-shadow"></div>

      <ul className="menu-inner py-1 overflow-auto">
        {/* Dashboard */}
        <li
          className={`menu-item ${
            location.pathname === "/super-admin/dashboard" ? "active" : ""
          }`}
        >
          <Link
            to="/super-admin/dashboard"
            className="menu-link"
            onClick={(e: any) => handleNavbarClick(e)}
          >
            <i className="menu-icon tf-icons ti ti-chart-bar"></i>
            <div data-i18n="Dashboard">Dashboard</div>
          </Link>
        </li>

        {/* Users */}
        <li
          className={`menu-item ${
            ["/super-admin/company", "/super-admin/create-company"].includes(
              location.pathname
            ) || location.pathname.startsWith("/super-admin/edit-company/")
              ? "active"
              : ""
          }`}
        >
          <Link
            to="/super-admin/company"
            className="menu-link"
            onClick={(e: any) => handleNavbarClick(e)}
          >
            <i className="menu-icon tf-icons ti ti-building"></i>
            <div data-i18n="Companay">Company</div>
          </Link>
        </li>

        {/* News Letter */}
         <li
          className={`menu-item ${
            location.pathname === "/super-admin/news-letter" ? "active" : ""
          }`}
        >
          <Link
            to="/super-admin/news-letter"
            className="menu-link"
            onClick={(e: any) => handleNavbarClick(e)}
          >
            <i className="menu-icon tf-icons ti ti-mail-opened"></i>
            <div data-i18n="news-letter">News Letters</div>
          </Link>
        </li>
         <li
          className={`menu-item ${
            location.pathname === "/super-admin/contact" ? "active" : ""
          }`}
        >
          <Link
            to="/super-admin/contact"
            className="menu-link"
            onClick={(e: any) => handleNavbarClick(e)}
          >
            <i className="menu-icon tf-icons ti ti-address-book"></i>
            <div data-i18n="contact">Contact</div>
          </Link>
        </li>
      </ul>
    </aside>
  );
};

export default SuperAdminSidebar;
